<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg large :sideMenu="true">
            <ProfileHeader></ProfileHeader>
        </TopBarBg>

        <PageContent class="flex-auto min-h-0" :hasPoweredBy="false">
            <div class="relative">
                <ProfileQuickMenu></ProfileQuickMenu>
                <ProfileCardList
                    id="profileCardList"
                    ref="cardList"
                    @onShowPopupCampaign="onShowPopupCampaign($event)"
                    @onLoading="loadingModal.show()"
                    @onLoaded="loadingModal.hide()"
                    @onError="errorApi($event)"
                    @onChageCardList="onChangeCardList($event)"
                ></ProfileCardList>
            </div>
        </PageContent>
        <div class="text-center text-blue-1 text-base underline mt-14" @click="openPrivacy()">{{ lbl.profile.privacySetting }}</div>
        <CancelMember @click="onClickCancelMember()"></CancelMember>
        <PowerByBzbs class="flex-none"></PowerByBzbs>
        <Footer :hasPoweredBy="false"></Footer>
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
        <BottomSheet
            v-model="showPopupCampaign"
            :dismissable="true"
            ref="btsPopupCampaign"
        >
            <div class="mt-7 mx-9 mb-9">
                <div
                    class="
                        text-center text-lg text-primary
                        leading-normal
                        uppercase
                        mx-6
                    "
                    v-html="lbl.profile.popupCampaign.title"
                ></div>
                <div class="text-center mt-4 mb-6 rounded-md">
                    <template v-if="campaignStates.campaign != null">
                        <img
                            @click="goToCampaign(campaignStates.campaign.id)"
                            :src="popupCampaignImg"
                            class="
                                w-auto
                                h-auto
                                max-h-180px max-w-270px
                                mx-auto
                                rounded-md
                                shadow-md
                            "
                        />
                    </template>
                </div>
                <div
                    class="mb-10px text-base text-primary text-center"
                    v-html="campaignStates.campaign.name"
                ></div>
                <div
                    class="text-center text-base text-red-1 mb-4"
                    v-text="availableQty"
                ></div>

                <div class="text-center">
                    <VBtn
                        blocked
                        large
                        variant="primary"
                        @click="goToCampaign(campaignStates.campaign.id)"
                    >
                        {{ lbl.redeem_button.default }}
                    </VBtn>
                </div>
            </div>
            <Footer :hasPoweredBy="false"></Footer>
        </BottomSheet>

        <BottomSheet
            ref="btsConfirmCancelMember"
            v-model="btsConfirmCancelMember"
            :persistent="false"
        >
            <div class="px-6 mt-6 text-center mb-8">
                <div>
                    <div class="text-lg text-primary uppercase">
                        {{ lbl.profile.popupCancelMember.title }}
                    </div>
                    <div class="mt-4">
                        <VBtn
                            blocked
                            large
                            variant="primary"
                            @click="doCancelMember()"
                            >{{ lbl.confirm_redeem.confirm }}</VBtn
                        >
                    </div>
                </div>
            </div>

            <template #dismiss="{ on }">
                <button type="button" class="outline-none" v-on="on">
                    <img src="@/assets/icon/dialog/close.svg" alt />
                </button>
            </template>
            <Footer :hasPoweredBy="false" />
        </BottomSheet>

        <BottomSheet
            ref="btsCancelMemberShipSuccess"
            v-model="btsCancelMemberShipSuccess"
            :persistent="false"
            @onClose="onClsoeCancelMembershipSuccess()"
        >
            <div class="px-6 -mt-10 text-center mb-8">
                <div class="mb-4">
                    <img
                        src="@/assets/icon/dialog/success.svg"
                        class="w-20 h-20 mx-auto"
                        alt
                    />
                </div>
                <div>
                    <div
                        class="text-lg text-primary uppercase"
                        v-html="lbl.profile.popupCancelMember.titleSuccess"
                    ></div>
                </div>
            </div>

            <template #dismiss="{ on }">
                <button type="button" class="outline-none" v-on="on">
                    <img src="@/assets/icon/dialog/close.svg" alt />
                </button>
            </template>
            <Footer :hasPoweredBy="false" />
        </BottomSheet>
    </div>
</template>
<script>
import { nextTick, computed as vueComputed } from "vue";
import Utility from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper";
import CacheHelper from "@/helper/CacheHelper";
import AccountHelper from "@/helper/AccountHelper";
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import ProfileHeader from "../component/ProfileHeader.vue";
import ProfileQuickMenu from "../component/ProfileQuickMenu.vue";
import ProfileCardList from "../component/ProfileCardList.vue";
import PowerByBzbs from "@/components/Layout/Footer/PowerByBzbs.vue";
import BottomSheet from "@/components/Dialog/BottomSheet.vue";
import VBtn from "@/components/Button/VBtn.vue";
import ModalMaster from "@/components/Modal/ModalMaster.vue"

//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin";
import LocaleMixin from "@/mixin/LocaleMixin";
import PdpaMixin from "@/mixin/PdpaMixin";

//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
// composable
import useRegisterCardComposable from "@/composables/RegisterCardComposable";
import useCampaignComposable from "@/composables/Campaigns/CampaignComposable";
import CancelMember from "../component/CancelMember.vue";

export default {
    name: "Profile",
    mixins: [ModalMixin, AuthPageMixin, ErrorApiMixin, LocaleMixin, PdpaMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        ProfileHeader,
        ProfileQuickMenu,
        ProfileCardList,
        PowerByBzbs,
        BottomSheet,
        VBtn,
        CancelMember,
        ModalMaster
    },
    data: function () {
        const { apiRegisterCreditCard } = useRegisterCardComposable();
        return {
            formData: null,
            checkTerms: false,
            trackingScreenName: "customer_profile",
            showPopupCampaign: false,
            btsConfirmCancelMember: false,
            btsCancelMemberShipSuccess: false,
            cardList: [],
            apiRegisterCreditCard,
        };
    },
    computed: {
        profilePhoto: function () {
            let user = AccountHelper.getCacheUser();
            if (user.line != null) {
                return user.line.pictureUrl;
            }
            return null;
        },
        availableQty: function () {
            if (this.campaignStates.campaign != null) {
                return Utility.stringFormat(
                    this.lbl.profile.popupCampaign.availableQty,
                    Utility.formatNum(this.campaignStates.campaign.qty)
                );
            }

            return Utility.stringFormat(
                this.lbl.profile.popupCampaign.availableQty,
                0
            );
        },
        popupCampaignImg: function () {
            if (this.campaignStates.campaign != null) {
                let pics = this.campaignStates.campaign?.pictures ?? [];
                if (pics.length == 2) {
                    return (
                        pics?.[1].fullImageUrl ??
                        pics?.[0].fullImageUrl ??
                        this.campaignStates.campaign.fullImageUrl
                    );
                } else {
                    return this.campaignStates.campaign.fullImageUrl;
                }
            }
            return null;
        },
    },
    provide: function () {
        return {
            modalControllerObj: vueComputed(() => this.modalController),
            profileObj: vueComputed(() => this.profile),
            profilePhoto: vueComputed(() => this.profilePhoto),
            label: this.lbl,
        };
    },
    setup: function () {
        const { apiVerifyCreditCard, apiCancelMember } =
            useRegisterCardComposable();

        const { apiGetCampaignDetail, states: campaignStates } =
            useCampaignComposable();

        return {
            campaignStates,
            apiGetCampaignDetail,
            apiVerifyCreditCard,
            apiCancelMember,
        };
    },
    created: function () {
        this.tracking.screenName(this.trackingScreenName);
    },
    methods: {
        checkThirdPartyRegisterSource: function () {
            const cache = new CacheHelper("local");
            const thirdpartySource = cache.getCache("thirdparty.register.source");
            if (thirdpartySource && thirdpartySource === "ADA") {
                if (this.cardList.length > 0) {
                    nextTick(() => {
                        // Remove cache after checking thirdparty.register.source
                        cache.removeCache("thirdparty.register.source");

                        this.alertBottomModal
                            .clearModal()
                            .setTitle(this.lbl.profile.thirdpartyIsCard.title)
                            .setMsg(this.lbl.profile.thirdpartyIsCard.msg)
                            .setBtnOk(this.lbl.profile.thirdpartyIsCard.btnOk)
                            .show();
                    });
                } else {
                    nextTick(() => {
                        this.successfulModal
                            .clearModal()
                            .setTitle(this.lbl.profile.thirdpartySource.title)
                            .setMsg(this.lbl.profile.thirdpartySource.msg)
                            .setBtnOk(this.lbl.profile.thirdpartySource.btnOk)
                            .setBtnApply(this.lbl.profile.thirdpartySource.btnApply)
                            .show();

                        this.successfulModal.onClickOk((type) => {
                            // Remove cache after checking thirdparty.register.source
                            cache.removeCache("thirdparty.register.source");

                            if (type == "add") {
                                this.addCardInProfile();
                            }
                            if (type == "apply") {
                                this.$router.push('/apply-card');
                            }
                        })
                    });
                }
            } else if (thirdpartySource && thirdpartySource === "ReceivePromotion") {
                nextTick(() => {
                    // Remove cache after checking thirdparty.register.source
                    cache.removeCache("thirdparty.register.source");

                    this.alertBottomModal
                        .clearModal()
                        .setTitle(this.lbl.profile.receivePromotion.title)
                        .setMsg(this.lbl.profile.receivePromotion.msg)
                        .setBtnOk(this.lbl.profile.receivePromotion.btnOk)
                        .show();
                });
            }
        },
        //#region mixin function
        onAccountInit: function () {
            this.formData = this.profile;

            this.checkUrlFlag();
        },
        //#endregion mixin function

        clickSave: function () {
            let profile = this.$refs["form-profile"].submit();
            if (profile == null) {
                return;
            }
            if (!this.checkAcceptTerms()) {
                return;
            }

            this.confirmModal.clearModal().setMsg("Save comfirm?").show();
            this.confirmModal.onClickOk(async () => {
                this.loadingModal.show();
                if (await this.sendUpdateProfile(profile)) {
                    await this.getProfile();
                }
                this.loadingModal.hide();
            });
        },

        checkAcceptTerms: function () {
            if (this.checkTerms) {
                return true;
            }

            this.alertBottomModal
                .clearModal()
                .setMsg("Please accept terms")
                .show();
            return false;
        },

        sendUpdateProfile: function (profile) {
            return new Promise((resolve) => {
                BzbsProfile.updateProfile(
                    profile,
                    null,
                    null,
                    null,
                    null
                ).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err, true, {
                            title: this.lbl.default.error,
                        });
                    },
                });
            });
        },
        getProfile: function () {
            return new Promise((resolve) => {
                BzbsProfile.getProfile().subscribe({
                    next: (data) => {
                        this.AccountStore.methods.setProfile(data.profile);
                        // this.AccountStore.methods.setAddress(data.address);
                        // this.AccountStore.methods.setShippingAddress(data.shippingAddress);
                        resolve();
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err, true, {
                            title: this.lbl.default.error,
                        });
                    },
                });
            });
        },

        checkUrlFlag: function () {
            // TODO: comment below line before push to source control
            // this.$nextTick(() => {
            //     this.$refs.cardList.refreshAfterVerify();
            // });

            if (this.$route.query.vc != null) {
                // verify card
                let cache = new CacheHelper("session");
                this.cleanUrl(cache);
                this.$refs.cardList.refreshAfterVerify();
            }
        },
        verifyCard: function () {
            let cache = new CacheHelper("session");
            let tranId = cache.getCache("registerCard.transId");
            if (tranId == null) {
                this.cleanUrl(cache);
                return; // do nothing after this line
            }

            this.apiVerifyCreditCard(tranId)
                .then((resp) => {
                    // console.log(resp)
                    if (resp.success) {
                        this.cleanUrl(cache);

                        this.$refs.cardList.refreshAfterVerify();
                    }
                })
                .catch((err) => {
                    // console.log(err)
                    if (err.code == "409") {
                        this.alertBottomModal
                            .setTitle(this.lbl.default.error)
                            .setMsg(err.message)
                            .onClose(() => {
                                this.cleanUrl(cache);
                            })
                            .show();
                    } else {
                        this.errorApi(err, true, {
                            title: this.lbl.default.error,
                            onClose: () => {
                                this.cleanUrl(cache);
                            },
                        });
                    }
                });
        },
        cleanUrl: function (cache) {
            // update query string by remove vc flag
            let query = Object.assign({}, this.$route.query);
            // remove tranid
            cache.removeCache("registerCard.transId");

            delete query.vc;
            this.$router.replace({
                query: query,
            });
        },
        onShowPopupCampaign: function (campaignId) {
            this.loadingModal.show();
            this.campaignStates.builder.setCampaignId(campaignId);
            this.apiGetCampaignDetail()
                .then((campaign) => {
                    // pre condition check
                    // expires, qty < 0 ?, publish
                    if (
                        campaign != null &&
                        campaign.qty > 0 &&
                        campaign.statusID == 3 &&
                        !DatetimeHelper.isCampaignExpires(campaign.expireDate)
                    ) {
                        this.$refs.btsPopupCampaign.show();
                    }
                })
                .finally(() => {
                    this.loadingModal.hide();
                });
        },
        goToCampaign: function (id) {
            this.$router.push({
                name: "promotion-detail",
                params: {
                    campaignId: id,
                },
            });
        },
        onClickCancelMember: function () {
            this.$refs.btsConfirmCancelMember.show();
        },
        doCancelMember: function () {
            this.loadingModal.show();
            this.$refs.btsConfirmCancelMember.hide();

            this.apiCancelMember()
                .then((resp) => {
                    if (resp.success) {
                        this.$refs.btsCancelMemberShipSuccess.show();
                    } else {
                        this.errorApi(resp);
                    }
                })
                .catch((err) => {
                    this.errorApi(err);
                })
                .finally(() => {
                    this.loadingModal.hide();
                });
        },
        onClsoeCancelMembershipSuccess: function () {
            // clear cache
            AccountHelper.removeCacheUser();
            this.$router.replace({
                name: "linelogin",
                query: {
                    target_page: "welcome",
                },
            });
        },
        openPrivacy: function () {
            this.$router.push("privacymenu")
        },
        addCardInProfile: function () {
            let baseUrl = Utility.getWebUrl("webhooks");
            let returnUrl = baseUrl + "/RegisterdCard?target_page=profile&source=ReceivePromotion";
            const token = AccountHelper.getToken();
            this.apiRegisterCreditCard(token, returnUrl)
                .then((resp) => {
                    if (resp.success) {
                        let cache = new CacheHelper("session");
                        cache.setCache("registerCard.transId", resp.data.tranId);
                        window.location.replace(resp.data.webPaymentUrl);
                    }
                })
                .catch((err) => {
                    this.errorApi(err);
                });
        },
        onChangeCardList: function (cardList) {
            this.cardList = cardList;
            console.log("🚀 ~ this.cardList:", this.cardList)
            this.checkThirdPartyRegisterSource();
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
